import axios from 'axios';
import { BASE_URL } from '../constants';

export const getCareer = (language = 'en', country = 'en') => {
    return axios.get(`${BASE_URL}/pages/career`, {
        params: {
            language,
            country,
        },
    });
};

export const getJob = params => {
    const { language, country, slug } = params;

    return axios.get(`${BASE_URL}/pages/career/${slug}`, {
        params: {
            language,
            country,
        },
    });
};
